// extracted by mini-css-extract-plugin
export var sliderRange = "_ox-2";
export var sliderRoot = "_ox-0";
export var sliderThumb = "_ox-3";
export var sliderTrack = "_ox-1";